import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        await loginWithGoogleSession(sid);
        toast.success("Signed in with Google");
        nav("/dashboard");
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="label-overline">Signing you in…</p>
    </div>
  );
}
